module.exports = __webpack_public_path__ + "img/confetti-top.5cac12c2.svg";